import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router';
// import { Helmet } from "react-helmet";
import { Col, Row, Form, Button, Input, Alert } from 'react-bootstrap';
import PasswordCheck from './PasswordCheck';
// import InCNavbar from './InCNavBar';
import '../../assets/styles/passwordcheck.css';
import {
  loginUser,
  setUserFromLocalStorage,
  sendOtp,
  verifyOtp,
  resetPassword,
  resetState,
} from '../../actions/authActions';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      number: '',
      otp: '',
      password: '',
      confirmPassword: '',
      resetLevel: 'enterNumber',
      charNumberValid: false,
      specialCharValid: false,
      uppercaseValid: false,
      lowercaseValid: false,
      numberValid: false,
      passwordsMatch: false,
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem('doosra-user-sessionToken') &&
      localStorage.getItem('doosra-user-sessionToken') != null
    ) {
      this.props.history.push('/user-dashboard');
    }
  }

  checkPasswordLength = (password) => {
    if (password.length >= 15) {
      this.setState({
        charNumberValid: true,
      });
    } else {
      this.setState({
        charNumberValid: false,
      });
    }
  };

  // Check for special characters
  checkSpecialCharacters = (password) => {
    const pattern = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
    if (pattern.test(password)) {
      this.setState({
        specialCharValid: true,
      });
    } else {
      this.setState({
        specialCharValid: false,
      });
    }
  };

  // Check for an uppercase character
  checkUppercase = (password) => {
    const pattern = /[A-Z]/;
    if (pattern.test(password)) {
      this.setState({
        uppercaseValid: true,
      });
    } else {
      this.setState({
        uppercaseValid: false,
      });
    }
  };

  // Check for an lowercase character
  checkLowercase = (password) => {
    const pattern = /[a-z]/;
    if (pattern.test(password)) {
      this.setState({
        lowercaseValid: true,
      });
    } else {
      this.setState({
        lowercaseValid: false,
      });
    }
  };

  // Check for a number
  checkNumber = (password) => {
    const pattern = /[0-9]/;
    if (pattern.test(password)) {
      this.setState({
        numberValid: true,
      });
    } else {
      this.setState({
        numberValid: false,
      });
    }
  };

  checkPasswordsMatch = () => {
    const { password, confirmPassword } = this.state;
    if (password && confirmPassword) {
      this.setState({ passwordsMatch: password === confirmPassword });
    }
  };

  verifyOtp = () => {
    // this.props.verifyOtp({otp,secret}).then((res)=>{
    // })
  };

  handleChange = (e) => {
    console.log(e.target.id, e.target.value);
    this.setState({ [e.target.id]: e.target.value }, () => {
      this.checkPasswordsMatch();
    });
    if (e.target.id == 'password') {
      this.checkPasswordLength(e.target.value);
      this.checkSpecialCharacters(e.target.value);
      this.checkUppercase(e.target.value);
      this.checkLowercase(e.target.value);
      this.checkNumber(e.target.value);
    }
  };

  handleResetAndLogin = (e) => {
    e.preventDefault();
    let data = {
      new_password: this.state.password,
      confirm_password: this.state.confirmPassword,
      phone_number: this.props.auth.phone_number,
    };
    if (!this.state.charNumberValid) return;
    if (!this.state.specialCharValid) return;
    if (!this.state.uppercaseValid) return;
    if (!this.state.numberValid) return;
    if (!this.state.passwordsMatch) return;

    this.props.resetPassword(data);
  };

  render() {
    if (!this.props.auth.is_valid_OTP) {
      return <Redirect to="/verify-otp" />;
    }
    if (this.props.auth.reset_password) {
      this.props.resetState();
      return <Redirect to="/" />;
    }
    const { seconds, otpDisabled } = this.state;
    return (
      <div>
        <Row>
          <Col sm={4}></Col>
          <Col sm={4} style={{ paddingTop: '10%' }}>
            <Form>
              <Form.Group>
                <Form.Label>New password:</Form.Label>
                <Form.Control
                  type="password"
                  onChange={this.handleChange}
                  value={this.state.password}
                  id="password"
                  placeholder="Enter your new password"
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Confirm password:</Form.Label>
                <Form.Control
                  type="password"
                  onChange={this.handleChange}
                  value={this.state.confirmPassword}
                  id="confirmPassword"
                  placeholder="should match with above new password"
                />
              </Form.Group>
              <Form.Group>
                <Button
                  type="button"
                  disabled={otpDisabled}
                  onClick={this.handleResetAndLogin}
                  style={{ marginLeft: 10 }}
                >
                  Submit
                </Button>
              </Form.Group>

              {this.state.error && (
                <Alert variant="danger">{this.state.error}</Alert>
              )}
              {this.props.error && (
                <Alert variant="success">{this.props.error}</Alert>
              )}
            </Form>
            <PasswordCheck
              charNumberValid={this.state.charNumberValid}
              specialCharValid={this.state.specialCharValid}
              uppercaseValid={this.state.uppercaseValid}
              lowercaseValid={this.state.lowercaseValid}
              numberValid={this.state.numberValid}
              passwordsMatch={this.state.passwordsMatch}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  error: state.auth.error,
});

export default connect(mapStateToProps, { resetPassword, resetState })(
  ResetPassword
);
